import './App.css';
import Routes from './Routes/Routes';

const App = () => <Routes/> 

export default App
